const isBrowser = () => typeof window !== "undefined";

export const ensureDataLayer = () => {
  if (!isBrowser()) {
    return undefined;
  }
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const pushToDataLayer = (payload) => {
  console.log("pushToDataLayer", payload);
  if (!payload || !isBrowser()) {
    return;
  }

  const dataLayer = ensureDataLayer();
  if (!dataLayer) {
    return;
  }

  dataLayer.push(payload);
};

export const withDataLayer = (callback) => {
  if (!isBrowser()) {
    return undefined;
  }

  const dataLayer = ensureDataLayer();
  if (dataLayer && typeof callback === "function") {
    return callback(dataLayer);
  }

  return undefined;
};
